/**
 * localStorage wrapper that never throws. Storage can be missing or blocked
 * (private browsing, embedded previews, quota), and the game must still run.
 */
const PREFIX = '3am-shift:v1:';

function backend(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

export function loadJson<T>(key: string, fallback: T, isValid?: (value: unknown) => value is T): T {
  try {
    const raw = backend()?.getItem(PREFIX + key);
    if (raw == null) return fallback;
    const parsed: unknown = JSON.parse(raw);
    if (isValid && !isValid(parsed)) return fallback;
    return parsed as T;
  } catch {
    return fallback;
  }
}

export function saveJson(key: string, value: unknown): void {
  try {
    backend()?.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* storage unavailable — progress simply isn't persisted */
  }
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
